import { SearchIcon } from 'components/icons'
import { useQuery } from 'hooks'
import { InputHTMLAttributes, memo, useState } from 'react'

interface SearchBarProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

const SearchBar = ({
  label,
  disabled = false,
  placeholder = 'Search here...',
  ...props
}: SearchBarProps) => {
  const { getQuery, removeQuery, setMultipleQueries } = useQuery()

  const defaultSearch: string = getQuery('search')
  const [searchTerm, setSearchTerm] = useState<string>(defaultSearch || '')

  const handleSubmitSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (searchTerm.trim().length > 0) {
      setMultipleQueries({
        search: searchTerm.trim(),
        page: 1,
      })
    } else {
      removeQuery('search')
    }
  }

  const handleChangeSearch = ({
    target,
  }: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = target
    if (value.length <= 0) {
      removeQuery('search')
    }
    setSearchTerm(value || '')
  }

  return (
    <div className="w-full min-w-52 max-w-xs">
      {/* Label */}
      {label && (
        <label
          htmlFor="search"
          className="mb-1 text-xs font-semibold text-sidebar-primary"
        >
          Search
        </label>
      )}
      {/* Input */}
      <form onSubmit={handleSubmitSearch}>
        <div
          className={`flex h-10 w-full items-center gap-2 rounded-lg border border-gray-200  px-2 focus:border-2 ${
            disabled ? 'cursor-not-allowed bg-gray-50' : 'bg-white'
          }`}
        >
          {/* Search Icon */}
          <div className="h-5 w-5 shrink-0 text-gray-400">
            <SearchIcon />
          </div>
          <input
            id="search"
            type="search"
            value={searchTerm}
            placeholder={placeholder}
            className={`h-full w-full bg-white text-sm text-primary  focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-600`}
            onChange={handleChangeSearch}
            disabled={disabled}
            {...props}
          />
        </div>
      </form>
    </div>
  )
}

export default memo(SearchBar)
